import {
  addDiscussionCommentReplies,
  addDiscussionComments,
  deleteDiscussionComment,
  deleteDiscussionCommentReplies,
  editDiscussionComments,
  getDiscussionCommentReplies,
  getDiscussionCommentsByPage,
  reactDiscussionComment,
  setRoomDisscussionCommentQuery,
  setRoomEditData,
} from '@/actions/room';
import AvatarComponent from '@/components/common/avatar';
import {
  calculateTopThreeEmojisUsed,
  calculateTotalCountLikes,
} from '@/helpers/dataHelper';
import formDataHelper from '@/helpers/formDataHelper';
import { CloseOutlined, SendOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Popconfirm, Typography } from 'antd';
import moment from 'moment';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'reactstrap';
import RepliesSection from '../Replies';
import { emojis, getReactColor } from '@/helpers/index';
import CommentContent from './comments.content';

const { Text } = Typography;

const CommentSection = ({
  roomId,
  discussionId,
  state,
  each,
  setState,
  setCommentEditId,
  commentEditId,
  setIsCommentReaction,
  setReactionCommentData,
  setReactionCommentId,
  setEmojiCountModal,
  setCommentDiscussionId,
  setReplyEditId,
  user,
  replyEditId,
  setIsReplyReaction,
  setReactionRepliesData,
  setReactionReplyId,
  roomSlug,
}) => {
  const dispatch = useDispatch();

  const roomDiscussionComments = useSelector(
    (state: any) => state.roomReducer.discussionComments
  );
  const { comments, replies } = roomDiscussionComments;

  // Local States
  const [commentText, setCommentText] = useState({});
  const [editCommentText, setEditCommentText] = useState('');
  const [editReplyText, setEditRepyText] = useState('');
  const [replyText, setReplyText] = useState({});
  const [replyState, setReplyState] = useState({
    open: {},
  });
  const [commentUserName, setCommentUserName] = useState('');

  const CommentMenu = ({ comment, each, isComment = true }) => {
    return (
      <Menu className="discussion-dropdown-menu p-2" style={{ borderRadius: '8px' }}>
        <Menu.Item className="pr-5 p-2" style={{ borderRadius: '8px' }}>
          <a
            onClick={() => {
              if (isComment) {
                setCommentEditId(comment.id);
                return setEditCommentText(comment.text);
              }
              setReplyEditId(comment.id);
              setEditRepyText(comment.text);
            }}
          >
            <div className="dropdown-media d-flex align-items-center px-2">
              <i className="fas fa-edit fa-lg text-muted mr-3"></i>
              <span className="mr-3">Edit comment</span>
            </div>
          </a>
        </Menu.Item>
        <Menu.Item className="pr-5 p-2" style={{ borderRadius: '8px' }}>
          <Popconfirm
            title="Delete Comment??"
            okText="Delete"
            onConfirm={() => {
              isComment
                ? onCommentDeleteClick(comment.id, each.id)
                : onCommentReplyDeleteClick(comment.id, each.id);
            }}
          >
            <div className="dropdown-media d-flex align-items-center px-2">
              <i className="fas fa-trash fa-lg text-muted mr-3"></i>
              <span>Delete comment</span>
            </div>
          </Popconfirm>
        </Menu.Item>
      </Menu>
    );
  };

  const loadMoreComments = (discussionId) => {
    dispatch(
      setRoomEditData({
        name: 'discussionComments',
        key: 'discussionId',
        value: discussionId,
      })
    );
    dispatch(
      setRoomDisscussionCommentQuery({
        payload: {
          page: comments[discussionId]?.query?.page + 1,
          doubt: discussionId,
          room: roomSlug,
        },
      })
    );

    dispatch(
      getDiscussionCommentsByPage({
        data: {
          ...comments[discussionId]?.query,
          doubt: discussionId,
          page: comments[discussionId]?.query?.page + 1,
          room: roomSlug,
        },
      })
    );
  };

  const handlePostComment = (id) => {
    dispatch(
      setRoomEditData({
        name: 'discussionComments',
        key: 'discussionId',
        value: discussionId,
      })
    );
    var data = {
      text: commentText[id].value,
      doubt: id,
      room: roomId,
    };
    dispatch(addDiscussionComments({ data }));
    setCommentText({
      [id]: {
        id,
        value: '',
      },
    });
  };

  const editCommentApi = (disId) => {
    dispatch(
      setRoomEditData({
        name: 'discussionComments',
        key: 'discussionId',
        value: disId,
      })
    );
    var data = {
      text: editCommentText,
    };
    dispatch(editDiscussionComments({ data, commentId: commentEditId }));
  };

  const handleAddReplies = (id) => {
    dispatch(
      setRoomEditData({
        name: 'discussionComments',
        key: 'commentId',
        value: id,
      })
    );
    setReplyText({
      [id]: {
        id,
        value: '',
      },
    });
    dispatch(
      addDiscussionCommentReplies({
        data: { room: roomId, comment: id, text: replyText[id].value },
      })
    );
  };

  const onCommentDeleteClick = (commentId, disId) => {
    dispatch(
      setRoomEditData({
        name: 'discussionComments',
        key: 'discussionId',
        value: disId,
      })
    );
    dispatch(deleteDiscussionComment({ commentId }));
  };

  const onReplyClick = (id) => {
    let linkOpenState = true;
    if (replyState.open.hasOwnProperty(id)) {
      linkOpenState = !replyState.open[id];
    }
    setReplyState({
      open: { ...replyState.open, [id]: linkOpenState },
    });
  };

  const onCommentReplyDeleteClick = (replyId, commentId) => {
    dispatch(
      setRoomEditData({
        name: 'discussionComments',
        key: 'commentId',
        value: commentId,
      })
    );
    dispatch(deleteDiscussionCommentReplies({ replyId }));
  };

  const onCommentLikeClick = (commentId, disId, reaction) => {
    dispatch(
      setRoomEditData({
        name: 'discussionComments',
        key: 'discussionId',
        value: disId,
      })
    );

    const values = {
      comment: commentId,
      reaction,
    };

    const value = formDataHelper(values, {});

    dispatch(reactDiscussionComment({ data: value }));
  };

  const handleShowReplyClick = (id) => {
    dispatch(
      setRoomEditData({
        name: 'discussionComments',
        key: 'commentId',
        value: id,
      })
    );
    setCommentDiscussionId(id);
    dispatch(
      getDiscussionCommentReplies({ data: { room: roomSlug, comment: id, page: 1 } })
    );
  };

  return (
    <>
      {state.open[each?.id] && (
        <div className="comments-wrap">
          <div className="d-flex justify-content-between">
            <span>Comments({each?.no_comment})</span>
            <div
              className="close-comment cursor-pointer"
              onClick={() => {
                setState({
                  open: { ...state.open, [each?.id]: false },
                });
                setCommentEditId(null);
              }}
            >
              <CloseOutlined rev="" />
            </div>
          </div>
          <div className="comment-body">
            {comments[each?.id]?.getRoomDiscussionComments === 'request' ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner animation="border" className="mt-3" />
              </div>
            ) : (
              comments[each?.id]?.data?.length !== 0 &&
              comments[each?.id]?.data?.map((comment, idx) => (
                <div className="comment-item align-items-stretch d-flex" key={idx}>
                  <div className="comment-left position-relative">
                    <AvatarComponent
                      size={36}
                      firstName={comment?.created_by?.first_name}
                      lastName={comment?.created_by?.last_name}
                      avatar={comment?.created_by?.avatar}
                    />
                  </div>
                  <div className="comment-content pb-2">
                    {commentEditId !== comment?.id && (
                      <CommentContent
                        comment={comment}
                        setIsCommentReaction={setIsCommentReaction}
                        setReactionCommentId={setReactionCommentId}
                        setReactionCommentData={setReactionCommentData}
                        setEmojiCountModal={setEmojiCountModal}
                        onCommentLikeClick={onCommentLikeClick}
                        setCommentUserName={setCommentUserName}
                        handleShowReplyClick={handleShowReplyClick}
                        onReplyClick={onReplyClick}
                        each={each}
                        user={user}
                        CommentMenu={CommentMenu}
                      />
                    )}

                    {!replyState.open[comment?.id] &&
                      comment?.total_replies > 0 &&
                      commentEditId !== comment?.id && (
                        //  && comment?.no_replies
                        <div
                          className="d-flex align-items-center cursor-pointer discussion--replies__hover"
                          onClick={() => {
                            setCommentUserName(
                              `${comment?.created_by?.first_name} ${comment?.created_by?.last_name}`
                            );
                            handleShowReplyClick(comment?.id);
                            onReplyClick(comment?.id);
                          }}
                        >
                          <i
                            className="fas fa-share float-left mt-1 mr-1"
                            style={{ transform: 'scaleY(-1)' }}
                          ></i>
                          <span
                            className="font-weight-bold"
                            style={{ lineHeight: '1' }}
                          >
                            View {comment?.total_replies}{' '}
                            {comment?.total_replies > 1 ? 'replies' : 'reply'}
                          </span>
                        </div>
                      )}

                    {commentEditId === comment.id && (
                      <div className="mb-2 reply-write-content">
                        <textarea
                          value={editCommentText}
                          onChange={(e) => {
                            setEditCommentText(e.target.value);
                          }}
                          placeholder="Edit your Comment here..."
                          className="text-area  w-100 p-2 border-0 "
                          style={{
                            borderRadius: '14px',
                            resize: 'none',
                            backgroundColor: 'rgb(240, 242, 245)',
                          }}
                        ></textarea>
                        <div className="d-flex align-items-center justify-content-end gap-3">
                          <Button
                            loading={
                              comments[each?.id].editRoomDiscussionCommentStatus ===
                              'request'
                                ? true
                                : false
                            }
                            className="d-flex btn-sm btn-primary border-danger mt-2 align-items-start"
                            onClick={() => editCommentApi(each?.id)}
                            disabled={editCommentText.length > 0 ? false : true}
                          >
                            Save
                          </Button>
                          <Button
                            className="d-flex btn-sm btn-secondary border-danger mt-2 align-items-start"
                            onClick={() => setCommentEditId(null)}
                          >
                            Cancel
                          </Button>
                        </div>
                      </div>
                    )}

                    {/* Room Comment Replies */}
                    <RepliesSection
                      replyState={replyState}
                      comment={comment}
                      replies={replies}
                      replyEditId={replyEditId}
                      CommentMenu={CommentMenu}
                      setReplyState={setReplyState}
                      user={user}
                      replyText={replyText}
                      handleAddReplies={handleAddReplies}
                      setReplyText={setReplyText}
                      commentUserName={commentUserName}
                      setIsReplyReaction={setIsReplyReaction}
                      setReactionRepliesData={setReactionRepliesData}
                      setEmojiCountModal={setEmojiCountModal}
                      setReactionReplyId={setReactionReplyId}
                      editReplyText={editReplyText}
                      setEditRepyText={setEditRepyText}
                      setReplyEditId={setReplyEditId}
                    />
                  </div>
                </div>
              ))
            )}
            {comments[each?.id]?.getMoreRoomDiscussionCommentsStatus ===
            'request' ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner animation="border" className="mt-3" />
              </div>
            ) : (
              comments[each?.id]?.getRoomDiscussionComments === 'success' &&
              comments[each?.id]?.meta?.last_pages !==
                comments[each?.id]?.query?.page && (
                <span
                  className="text-primary cursor-pointer d-flex justify-content-center"
                  style={{ fontSize: '0.767rem' }}
                  onClick={() => loadMoreComments(each.id)}
                >
                  <u>Load More Comments</u>
                </span>
              )
            )}
          </div>

          <div className="write-content mt-2">
            <div className="post-compose">
              <div className="post-content">
                <div className="post-field d-flex align-items-center">
                  <div className="mr-2">
                    <AvatarComponent
                      avatar={user?.avatar}
                      size={36}
                      firstName={user?.first_name}
                      lastName={user?.last_name}
                    />
                  </div>

                  <div className="position-relative w-100">
                    <textarea
                      value={commentText[each.id] && commentText[each.id]?.value}
                      onChange={(e) => {
                        setCommentText({
                          ...commentText,
                          [each.id]: {
                            id: each.id,
                            value: e.target.value,
                          },
                        });
                      }}
                      placeholder="Type your Comment here..."
                      className="text-area w-100 pl-3 pr-5 py-2 border-0"
                      style={{
                        borderRadius: '25px',
                        height: '40px',
                        resize: 'none',
                        backgroundColor: 'rgb(240, 242, 245)',
                      }}
                    />
                    <SendOutlined
                      rev=""
                      className={`position-absolute ${
                        commentText[each.id]?.value?.length > 0
                          ? 'cursor-pointer'
                          : 'cursor-disabled'
                      }`}
                      style={{
                        top: '12px',
                        right: '10px',
                        fontSize: '15px',
                        color: `${commentText[each.id]?.value ? '#283360' : ''}`,
                      }}
                      disabled={commentText[each.id]?.value?.length === 0}
                      onClick={() =>
                        commentText[each.id]?.value?.length > 0 &&
                        handlePostComment(each.id)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CommentSection;
